import api from './api';

const toFolderPayload = (folderData = {}) => ({
  name: String(folderData?.name ?? '').trim(),
  parentId: String(folderData?.parentId ?? 'root').trim() || 'root',
});

const toFileNamesPayload = (fileNames = []) => ({
  fileNames: Array.isArray(fileNames)
    ? fileNames.map((name) => String(name ?? '').trim()).filter(Boolean)
    : [],
});

export async function fetchFoldersByParent(parentId = "root") {
  const response = await api.get(`/folders/children/${parentId}`);
  return response.data;
}

export async function createFolder(folderData) {
  const response = await api.post("/folders", toFolderPayload(folderData));
  return response.data;
}

export const uploadFileToFolder = (folderId, formData) =>
  api.post(`/folders/${folderId}/upload`, formData);

export async function deleteFolder(folderId) {
  const response = await api.delete(`/folders/${folderId}`);
  return response.data;
}

export async function deleteFile(folderId, fileId) {
  const response = await api.delete(`/folders/${folderId}/files/${encodeURIComponent(fileId)}`);
  return response.data;
}

export async function fetchFolderById(folderId) {
  const response = await api.get(`/folders/detail/${folderId}`);
  return response.data;
}

export const uploadMultipleFilesToFolder = (folderId, formData) =>
  api.post(`/folders/${folderId}/upload-multiple`, formData);

export async function downloadFolderAsZip(folderId) {
  const response = await api.get(`/folders/${folderId}/download-all`, {
    responseType: "blob", // important!
  });
  return response.data;
}

export async function deleteMultipleFiles(folderId, fileNames) {
  const response = await api.delete(`/folders/${folderId}/files`, {
    data: toFileNamesPayload(fileNames),
  });
  return response.data;
}

export async function downloadSelectedFiles(folderId, fileNames) {
  const response = await api.post(
    `/folders/${folderId}/download-selected`,
    toFileNamesPayload(fileNames),
    {
      responseType: "blob",
    }
  );
  return response.data;
}
